export class Product {
    
        constructor(
            public id?: number,
            public name?: string,
            public category?: string,
            public description?: string,
            public price?: number) { }
    }


// WEBPACK FOOTER //
// C:/Users/BiggaHD/Desktop/projects/sportStore/src/app/model/product.model.ts